<template>
  <div>
    <vue-snotify></vue-snotify>
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"
             color="#00F">
    </loading>
    <b-row style="text-align:center;display:none;">
      <b-col cols="3"></b-col>
      <b-col cols="5">
        <h1 class="h1">
          <strong>{{ form_title }}</strong>
        </h1>
        <h4 class="small-text">{{ form_description }}</h4>
      </b-col>
      <b-col cols="4"></b-col>
    </b-row>

    <ValidationObserver ref="form" v-slot="{ passes }">
      <b-form action="#" @submit.prevent="passes(submitUser)">
        <!-- user role  -->
        <ValidationProvider
            vid="role"
            name="User Role"
            v-slot="{ errors }"
            rules="required"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">User Role</span>
            </b-col>
            <b-col cols="5">
              <select
                  id="role_id"
                  v-model="selected_role"
                  class="form-control form-control-lg"
                  :disabled="action_type === 'View' || user_name == 'superadmin'"
              >
                <option value="">--PLEASE SELECT--</option>
                <option
                    v-for="(role, index) in roles"
                    :value="role.id"
                    :key="index"
                >{{ role.name }}
                </option
                >
              </select>
            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div v-if="!errors[0]" class="color-box color-box-user-id">
                <p>
                  <span style="color:red">*</span>The User Role field is
                  required
                </p>
              </div>
              <div v-else class="color-box-v color-box-user-id-v">
                <p v-for="(error, index) in errors" v-bind:key="index">
                  {{ error }}
                </p>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <!--Parent -->
        <ValidationProvider
            vid="parent_id"
            name="Level One Account"
            v-slot="{ errors }"
            v-if="parent_display"
            rules="required:parent_display"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Level One Account</span>
            </b-col>
            <b-col cols="5">
              <select
                  id="parent_id"
                  v-model="parent_id"
                  class="form-control form-control-lg"
                  :disabled="action_type === 'View'"
                  v-on:change="getParentData()"
              >
                <option value="">Choose</option>
                <option
                    v-for="(parent, index) in parent_list"
                    :value="parent.id"
                    :key="index"
                >{{ parent.name }}
                </option
                >
              </select>
            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div v-if="!errors[0]" class="color-box color-box-user-id">
                <p>
                  <span style="color:red">*</span>The Level One Account field is
                  required
                </p>
              </div>
              <div v-else class="color-box-v color-box-user-id-v">
                <p v-for="(error, index) in errors" v-bind:key="index">
                  {{ error }}
                </p>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <!-- Company -->
        <ValidationProvider
            v-if="company_display"
            vid="company"
            name="Company"
            v-slot="{ errors }"
            rules="required"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Company</span>
            </b-col>
            <b-col cols="5">
              <input
                  id="company"
                  type="text"
                  placeholder="Company"
                  class="form-control form-control-lg"
                  v-model="company"
                  :disabled="
                  action_type === 'View' ||
                    company_disable == false ||
                    level == 4
                "
              />
            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div>
                <div v-if="!errors[0]" class="color-box color-box-user-id">
                  <p>
                    <span style="color:red">*</span>The Company field is
                    required
                  </p>
                </div>
                <div v-else class="color-box-v color-box-user-id-v">
                  <p v-for="(error, index) in errors" v-bind:key="index">
                    {{ error }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <!-- Firstname-->
        <ValidationProvider
            vid="first_name"
            name="FirstName"
            rules="required"
            v-slot="{ errors }"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">First name</span>
            </b-col>
            <b-col cols="5">
              <b-form-input
                  id="first_name"
                  type="text"
                  placeholder="First name"
                  class="form-control form-control-lg to-uppercase"
                  v-model="first_name"
                  data-vv-as="First name"
                  :disabled="action_type === 'View'"
                  v-uppercase
              ></b-form-input>
            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div>
                <div v-if="!errors[0]" class="color-box color-box-user-id">
                  <p>
                    <span style="color:red">*</span>The First Name field is
                    required
                  </p>
                </div>
                <div v-else class="color-box-v color-box-user-id-v">
                  <p v-for="(error, index) in errors" v-bind:key="index">
                    {{ error }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>
        <!-- Lastname -->
        <ValidationProvider
            vid="last_name"
            name="LastName"
            v-slot="{ errors }"
            rules="required"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Last name</span>
            </b-col>
            <b-col cols="5">
              <b-form-input
                  id="last_name"
                  type="text"
                  placeholder="Last name"
                  class="form-control form-control-lg to-uppercase"
                  v-model="last_name"
                  :disabled="action_type === 'View'"
                  v-uppercase
              ></b-form-input>
            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div>
                <div v-if="!errors[0]" class="color-box color-box-user-id">
                  <p>
                    <span style="color:red">*</span>The Last name field is
                    required
                  </p>
                </div>
                <div v-else class="color-box-v color-box-user-id-v">
                  <p v-for="(error, index) in errors" v-bind:key="index">
                    {{ error }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <!-- Email-->
        <ValidationProvider
            vid="email"
            name="Email"
            v-slot="{ errors }"
            rules="required"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Email</span>
            </b-col>
            <b-col cols="5">
              <b-form-input
                  id="email"
                  type="email"
                  placeholder="Email"
                  class="form-control form-control-lg to-lowercase"
                  v-model="email"
                  :disabled="action_type === 'View'"
                  v-lowercase
              ></b-form-input>
            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div>
                <div v-if="!errors[0]" class="color-box color-box-user-id">
                  <p><span style="color:red">*</span>The Email field is required</p>
                </div>
                <div v-else class="color-box-v color-box-user-id-v">
                  <p v-for="(error, index) in errors" v-bind:key="index">
                    {{ error }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>
        <!-- contact number -->
        <ValidationProvider
            vid="contact_no"
            name="Contact Number"
            rules="required|digits:10"
            v-slot="{ errors }"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Contact Number</span>
            </b-col>
            <b-col cols="5">
              <input
                  @keypress="isNumber($event)"
                  id="contact_no"
                  type="text"
                  placeholder="Contact Number"
                  class="form-control form-control-lg"
                  v-model="contact_no"
                  :disabled="action_type === 'View'"
              />
            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div>
                <div v-if="!errors[0]" class="color-box color-box-user-id">
                  <p>
                    <span style="color:red">*</span>The Contact Number field is
                    required
                  </p>
                </div>
                <div v-else class="color-box-v color-box-user-id-v">
                  <p v-for="(error, index) in errors" v-bind:key="index">
                    {{ error }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <b-row
            class="row-top"
            v-if="
            payment_display ||
              payment_on_credit_display ||
              payment_display ||
              payment_credit_card_display
          "
        >
          <b-col cols="3">
            <span class="span">Payment Mode</span>
          </b-col>
          <b-col cols="5">
            <!-- Payment On Credit-->
            <ValidationProvider
                vid="payment_on_credit"
                name="Payment on Credit"
                rules="required"
                v-if="payment_display || payment_on_credit_display"
            >
              <b-row class="row">
                <b-col cols="3">
                  <span class="span" style="float:left;"
                  >On Credit</span
                  >
                </b-col>
                <b-col cols="9">
                  <div class="toggle-button-cover">
                    <!--<div class="button-cover">-->
                    <div class="button r" id="button-1">
                      <input
                          type="checkbox"
                          :value="true"
                          class="checkbox"
                          v-model="payment_on_credit"
                          :disabled="action_type === 'View'"
                      />
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                    <!--</div>-->
                  </div>
                </b-col>
              </b-row>
            </ValidationProvider>

            <!-- Payment Credit Card-->
            <ValidationProvider
                vid="payment_credit_card"
                name="Payment Credit Card"
                rules="required"
                v-if="payment_display || payment_credit_card_display"
            >
              <b-row class="row">
                <b-col cols="3">
                  <span class="span" style="float:left;"
                  >Credit Card</span
                  >
                </b-col>
                <b-col cols="9">
                  <div class="toggle-button-cover">
                    <!--<div class="button-cover">-->
                    <div class="button r" id="button-1">
                      <input
                          type="checkbox"
                          :value="true"
                          class="checkbox"
                          v-model="payment_credit_card"
                          :disabled="action_type === 'View'"
                      />
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                    <!--</div>-->
                  </div>
                </b-col>
              </b-row>
            </ValidationProvider>
          </b-col>
        </b-row>

        <!-- BR Code -->
        <ValidationProvider
            vid="br_code"
            name="Branch"
            v-slot="{ errors }"
            rules=""
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Branch</span>
            </b-col>
            <b-col cols="5">
              <v-select
                  label="name"
                  :options="branch_list"
                  v-model="br_code"
                  :reduce="data => data.name"
                  :disabled="action_type === 'View'"
                  placeholder="--PLEASE SELECT--"
              ></v-select>

            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div>
                <div v-if="errors[0]" class="color-box-v color-box-user-id-v">
                  <p v-for="(error, index) in errors" v-bind:key="index">
                    {{ error }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <!-- Introducer code -->
        <ValidationProvider
            v-if="company_display"
            vid="introducer"
            name="Introducer"
            v-slot="{ errors }"
            rules="max:10"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Introducer Code</span>
            </b-col>
            <b-col cols="5">
              <input
                  id="introducer"
                  type="text"
                  placeholder="Introducer Code"
                  class="form-control form-control-lg"
                  v-model="introducer"
                  :disabled="action_type === 'View'"
              />
            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div>
                <div v-if="errors[0]" class="color-box-v color-box-user-id-v">
                  <p v-for="(error, index) in errors" v-bind:key="index">
                    {{ error }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>
        <!--        &lt;!&ndash; Agent code &ndash;&gt;-->
        <ValidationProvider
            vid="agent_code"
            name="Agent Code"
            v-slot="{ errors }"
            rules="max:10"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Agent Code</span>
            </b-col>
            <b-col cols="5">
              <b-form-input
                  id="agent_code"
                  type="text"
                  placeholder="Agent Code"
                  class="form-control form-control-lg to-uppercase"
                  v-model="agent_code"
                  :disabled="action_type === 'View'"
                  v-uppercase
              ></b-form-input>
            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div>
                <div v-if="errors[0]" class="color-box-v color-box-user-id-v">
                  <p v-for="(error, index) in errors" v-bind:key="index">
                    {{ error }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <!-- Username -->
        <ValidationProvider
            vid="user_name"
            name="Username"
            v-slot="{ errors }"
            rules="required"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Username</span>
            </b-col>
            <b-col cols="5">
              <b-form-input
                  id="user_name"
                  type="text"
                  placeholder="Username"
                  class="form-control form-control-lg to-lowercase"
                  v-model="user_name"
                  data-vv-as="Username"
                  :disabled="action_type === 'View' || user_name == 'superadmin' "
                  v-lowercase
              ></b-form-input>
            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div>
                <div v-if="!errors[0]" class="color-box color-box-user-id">
                  <p>
                    <span style="color:red">*</span>The Username field is
                    required
                  </p>
                </div>
                <div v-else class="color-box-v color-box-user-id-v">
                  <p v-for="(error, index) in errors" v-bind:key="index">
                    {{ error }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <!-- password -->
        <ValidationProvider
            v-if="action_type === 'Create'"
            name="Password"
            v-slot="{ errors }"
            vid="password"
            rules="required"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Password</span>
            </b-col>
            <b-col cols="5">
              <input
                  id="password"
                  type="password"
                  placeholder="Password"
                  class="form-control form-control-lg"
                  v-model="password"
              />
              <span style="color:#ffc107;font-size: 11px;"
              >Password must be at least 6 characters and contain at least 1
                special character.</span
              >
            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div>
                <div v-if="!errors[0]" class="color-box color-box-user-id">
                  <p>
                    <span style="color:red">*</span>The password field is required
                  </p>
                </div>
                <div v-else class="color-box-v color-box-user-id-v">
                  <p v-for="(error, index) in errors" v-bind:key="index">
                    {{ error }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <!-- password confirmation-->
        <ValidationProvider
            v-if="action_type === 'Create'"
            name="Password Confirmation"
            v-slot="{ errors }"
            rules="required|confirmed:password"
            vid="password_confirmation"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Password Confirmation</span>
            </b-col>
            <b-col cols="5">
              <input
                  id="password_confirmation"
                  type="password"
                  placeholder="Password Confirmation"
                  class="form-control form-control-lg"
                  v-model="password_confirmation"
              />
            </b-col>
            <b-col cols="4" v-if="action_type != 'View'">
              <div v-if="!errors[0]" class="color-box color-box-user-id">
                <p>
                  <span style="color:red">*</span>The password confirmation field is
                  required
                </p>
              </div>
              <div v-else class="color-box-v color-box-user-id-v">
                <p v-for="(error, index) in errors" v-bind:key="index">
                  {{ error }}
                </p>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <!--status-->

        <b-row class="row-top" v-if="action_type == 'View'">
          <b-col cols="3">
            <span class="span">Status</span>
          </b-col>
          <b-col cols="5">
            <select
                id="status"
                v-model="user_status"
                class="form-control form-control-lg"
                :disabled="action_type === 'View'"
            >
              <option value="">Choose</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </b-col>
          <b-col cols="4" v-if="action_type != 'View'">
            <div v-if="!errors[0]" class="color-box color-box-user-id">
              <p>
                <span style="color:red">*</span>The Status field is required
              </p>
            </div>
            <div v-else class="color-box-v color-box-user-id-v">
              <p v-for="(error, index) in errors" v-bind:key="index">
                {{ error }}
              </p>
            </div>
          </b-col>
        </b-row>

        <!-- Remark for inactive user-->
        <b-row class="row-top" v-if="action_type == 'View' && user_status == 0">
          <b-col cols="3">
            <span class="span">Reason</span>
          </b-col>
          <b-col cols="5">
            <b-form-textarea
                id="reject_reason"
                v-model="reject_reason"
                placeholder="Reason"
                rows="3"
                max-rows="6"
                :disabled="action_type === 'View'"
            ></b-form-textarea>
          </b-col>
          <b-col cols="4" v-if="action_type != 'View'">
            <div v-if="!errors[0]" class="color-box color-box-user-id">
              <p><span style="color:red">*</span>The Reason is required</p>
            </div>
            <div v-else class="color-box-v color-box-user-id-v">
              <p v-for="(error, index) in errors" v-bind:key="index">
                {{ error }}
              </p>
            </div>
          </b-col>
        </b-row>

        <!-- Create -->
        <b-row class="row-top row-bottom">
          <b-col cols="3">
            <span class="span"></span>
          </b-col>
          <b-col cols="5">
            <b-row>
              <b-col cols="6">
                <b-button
                    v-if="action_type != 'View'"
                    type="submit"
                    block
                    variant="primary"
                    size="lg"
                >{{ btn_label }}
                </b-button
                >
              </b-col>
              <b-col cols="6">
                <router-link to="/users">
                  <b-button block size="lg">Cancel</b-button>
                </router-link>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="4">
            <div></div>
          </b-col>
        </b-row>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import {extend} from "vee-validate/dist/vee-validate.full";
import {http} from "@/config/http";
import _ from "lodash";

export default {
  name: "UserCreate",
  data() {
    return {
      payment_credit_card: false,
      payment_on_credit: false,
      user_name: "",
      title: "",
      first_name: "",
      last_name: "",
      introducer: "",
      agent_code: "",
      br_code: "",
      email: "",
      company: "",
      contact_no: "",
      user_id: "",
      password: "",
      password_confirmation: "",
      action_type: "Create",
      btn_label: "Save",
      form_title: "User Creation",
      form_description: "Enter the required details to create the user",
      roles: [],
      selected_role: "",
      parent_id: "",
      user_status: "",
      parent_display: false,
      payment_display: false,
      company_disable: true,
      company_display: false,
      payment_on_credit_display: false,
      payment_credit_card_display: false,
      parent_list: [],
      reject_reason: "",
      isLoading: false,
      fullPage: true,
    };
  },
  async created() {
    if (this.$route.params.user_id) {
      await this.findUser(this.$route.params.user_id);
      this.action_type = "Edit";
      this.form_title = "Edit the User";
      this.form_description = "Enter the required details to edit the user";
      this.btn_label = "Update";
    } else if (this.$route.params.id) {
      await this.findUser(this.$route.params.id);
      this.action_type = "View";
      this.form_title = "View User";
      this.form_description = "Created user account information";
    }
    this.getRoles();
    this.getBranchList();
  },
  computed: {
    ...mapState("user", ["userData", "role_list", "errors" , "branch_list"]),
    ...mapState("login", ["level", "user_company"]),
  },
  methods: {
    ...mapActions("user", [
      "createUser",
      "updateUser",
      "getUserData",
      "getRoleList",
      "resetUserData",
      "getBranchDataList",
      "setBranchList"
    ]),
    async getBranchList() {
      let table = 'param_branches';
      const data = {
        table: table,
        type: 'branch_list',
        param_type: 'name'
      };
      await this.getBranchDataList(data);
    },

    async clearData() {
      await this.resetUserData();
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    async submitUser() {
      this.isLoading = true;
      // if (isValid) {
      const userdata = {
        title: this.title,
        user_name: this.user_name,
        first_name: this.first_name,
        last_name: this.last_name,
        agent_code: this.agent_code,
        br_code: this.br_code,
        contact_no: this.contact_no,
        parent_id: this.parent_id,
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation,
        role: this.selected_role,
        active: this.user_status,
        reject_reason: this.reject_reason,
      };
      if (this.$route.params.user_id) {
        userdata.user_id = this.$route.params.user_id;
        await this.updateUser(userdata).then((response) => {
          this.$snotify.clear();
          if (response.data.success) {
            this.clearData().then(() => {
              this.$snotify
                  .success(response.data.success.message, "", {
                    position: "centerTop",
                  })
                  .on("destroyed", () => this.$router.push("/users"));
            });
            // router.push('/roles');
          } else {
            this.$snotify.error(response.data.error.message, "Error!", {
              position: "centerTop",
            });
          }
          this.isLoading = false;
        });
      } else {
        await this.createUser(userdata).then((response) => {
          this.isLoading = false;
          this.$snotify.clear();
          if (response.data.success) {
            this.clearData().then(() => {
              this.$refs.form.reset();
              this.$snotify
                  .success(response.data.success.message, "", {
                    position: "centerTop",
                  })
                  .on("destroyed", () => this.$router.push("/users"));
            });
            // router.push('/roles');
          } else {
            this.$snotify.error(response.data.error.message, "Error!", {
              position: "centerTop",
            });
          }
        });
      }
      this.$refs.form.setErrors(this.errors);
      // }
    },
    async findUser(user_id) {
      await this.getUserData(user_id);
      this.title = this.userData.title;
      this.first_name = this.userData.first_name;
      this.last_name = this.userData.last_name;
      this.email = this.userData.email;
      this.agent_code = this.userData.agent_code;
      this.br_code = this.userData.br_code;
      this.contact_no = this.userData.contact_no;
      this.user_id = this.userData.id;
      this.user_name = this.userData.user_name;
      this.selected_role = this.userData.role;
      this.parent_id = this.userData.parent_id;
      this.user_status = this.userData.user_status;
    },

    async getRoles() {
      await this.getRoleList();
      this.roles = this.role_list;
    },
  },
};
</script>

<style scoped>
.to-uppercase{
  text-transform: uppercase
}
.to-lowercase{
  text-transform: lowercase;
}


.disbled-card {
  pointer-events: none;
}

.small-text {
  color: #73818f;
}

.h1 {
  margin-bottom: 0rem !important;
}

.row-top {
  margin-top: 30px;
}

.row-bottom {
  margin-bottom: 50px;
}

.span {
  float: right;
  margin-top: 12px;
  color: #73818f;
  font-weight: 400;
}

::placeholder {
  color: #73818f;
  font-weight: 200;
  font-size: 14px;
  font-style: italic;
}

.role-row {
  margin-bottom: 20px;
}

.container {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.wrapper {
  margin: 0px !important;
}

.wrapper .container .bottom .left .details {
  padding: 10px 0 0 18px !important;
  width: calc(70% - 0px) !important;
}

.wrapper .container .bottom .left .add i {
  padding: 9px !important;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #ffffff;
  margin-top: 25px;
}

.wrapper .container .bottom .right .done i {
  padding: 10px !important;
}

.wrapper .container .bottom .right .details {
  padding: 10px !important;
  float: right;
  width: calc(70% - 4px) !important;
}

.wrapper .container .bottom .right .remove i {
  padding: 12px !important;
}

.wrapper .container .bottom .right .remove {
  height: 58% !important;
}

.role-card {
  margin-left: 12px;
}

/* ---- start toggle css ----- */

* {
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

*:focus {
  outline: none;
}

.toggle-button-cover {
  display: table-cell;
  position: relative;
  /*width: 200px;*/
  height: 50px;
  box-sizing: border-box;
}

.button-cover {
  height: 100px;
  margin: 20px;
  background-color: #fff;
  box-shadow: 0 10px 20px -8px #c5d6d6;
  border-radius: 4px;
}

.button-cover:before {
  counter-increment: button-counter;
  content: counter(button-counter);
  position: absolute;
  right: 0;
  bottom: 0;
  color: #d7e3e3;
  font-size: 12px;
  line-height: 1;
  padding: 5px;
}

.button-cover,
.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.button {
  position: relative;
  top: 50%;
  width: 74px;
  height: 36px;
  margin: -20px auto 0 auto;
  overflow: hidden;
}

.button.r,
.button.r .layer {
  border-radius: 100px;
}

.button.b2 {
  border-radius: 2px;
}

.checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.knobs {
  z-index: 2;
}

.layer {
  width: 100%;
  background-color: #fcebeb;
  transition: 0.3s ease all;
  z-index: 1;
}

/* Button 1 */
#button-1 .knobs:before {
  content: "NO";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 30px;
  height: 30px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  background-color: #f44336;
  line-height: 1;
  padding: 9px 4px;

  border-radius: 50%;
  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
}

#button-1 .checkbox:checked + .knobs:before {
  content: "YES";
  left: 42px;
  background-color: #03a9f4;
}

#button-1 .checkbox:checked ~ .layer {
  background-color: #ebf7fc;
}

#button-1 .knobs,
#button-1 .knobs:before,
#button-1 .layer {
  transition: 0.3s ease all;
}

/* ---- end of toggle css ---- */
</style>
